import { Icon, IconArrowLeft } from "@flixbus/honeycomb-icons-react";
import { Button, Heading } from "@flixbus/honeycomb-react";
import { Feature, hasUserPermission, mpoPathnames as pathnames } from "@flixbus-phx/marketplace-common";
import image from "@flixbus-phx/marketplace-common/assets/illustrations/access_forbidden.svg";
import * as React from "react";
import { FormattedMessage } from "react-intl";
import { useNavigate } from "react-router-dom";
import ChangeSelectedPartnerButton from "../../../changeSelectedPartnerButton/ChangeSelectedPartnerButton";
import * as css from "./NoBookingDataAccessAllowedMessage.scss";

const NoBookingDataAccessAllowedMessage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className={css.wrapper}>
      <div className={css.header}>
        <Heading size={2} flushSpace>
          <FormattedMessage id="general.accessRestricted" />
        </Heading>
        <div className={css.text}>
          <FormattedMessage id="bookingInfo.nobookingDataAccessAllowed.text" />
        </div>
      </div>
      {hasUserPermission(Feature.VIEW_PARTNER_LIST) && (
        <div className={css.topButtonWrapper}>
          <ChangeSelectedPartnerButton />
        </div>
      )}

      <img src={image} alt="" />
      <div className={css.buttonWrapper}>
        <Button appearance="link" onClick={() => navigate(pathnames.capacityManager)}>
          <Icon InlineIcon={IconArrowLeft} />
          <FormattedMessage id="general.backToCapacityManager" />
        </Button>
      </div>
    </div>
  );
};

export default NoBookingDataAccessAllowedMessage;
